import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { header, subHeader, body } from "@components/onboarding-nux/OnboardingNUX.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

// assets
import { chromeProductOnboardingTeam } from "@img/illustrations";

export const singleContainer: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: greys.palePaleGrey,
  padding: 68,
};

export const configurationPane: CSSProperties = {
  width: 600,
};

export const pills: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  borderRadius: 20,
  minHeight: 43,
  background: greys.palePaleGrey,
  padding: 4,
  marginBottom: 34,

  "& > .pill": {
    cursor: "pointer",
    borderRadius: 20,
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    color: colors.blueDusk.standard,
    fontSize: "15px",
    fontWeight: "bold",
    marginRight: 4,

    "& svg": {
      marginRight: 10,
    },

    "&.active": {
      cursor: "default",
      background: greys.white,
      boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.15)",

      "&:hover": {
        background: greys.white,
        boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.15)",
      },
    },

    "&:hover": {
      background: greys.paleGrey,
    },

    "&:last-child": {
      marginRight: 0,
    },
  },
};

const control: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

const controlWithWarning: CSSProperties = {
  display: "flex",
  flexDirection: "column",
};

export const controlContent: CSSProperties = {
  display: "flex",
  flex: 1,
  flexDirection: "row",
  alignItems: "center",
  overflow: "hidden",
  "& .title-names": {
    flex: 1,
    "& .title": {
      fontSize: "16px",
      color: greys.slate,
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",

      "& .suggested": {
        marginLeft: 6,
        cursor: "pointer",
        color: colors.green.darker,
        fontSize: "14px",
        paddingBottom: 2,
        borderBottom: `1px dashed ${colors.green.darker}`,
      },
    },

    "& .persons-names": {
      color: greys.blueGrey,
      fontSize: "14px",
      marginTop: 6,
    },
  },
  "& .avatars": {
    paddingRight: 8,
  },
};

const teamSizeWarning: CSSProperties = {
  display: "flex",
  alignItems: "center",
};

const warningIcon: CSSProperties = {
  color: colors.peach.darker,
  margin: "0 5px",
  width: 16,
};

const warningLabel: CSSProperties = {
  flexGrow: 1,
  fontSize: 12,
  color: colors.peach.darker,
  paddingTop: 2,
};

export const stickyContainer: CSSProperties = {
  position: "sticky",
  top: -50,
  display: "flex",
  flexDirection: "column",
  background: greys.white,
  zIndex: 1,
  marginTop: -50,
  paddingTop: 50,
};

export const teamSettingsSearchContainer: CSSProperties = {
  padding: 0,
};

export const illustration: CSSProperties = {
  flex: 1,
  width: "100%",
  margin: 75,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundImage: `url(${chromeProductOnboardingTeam})`,
};

export const checkList: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",

  "& > div": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    "& .check svg": {
      color: colors.green.standard,
      marginRight: 15,
    },
    "& .text": {
      color: greys.slate,
    },
  },
};

export const teamSearchTextField: CSSProperties = {
  marginBottom: 14,
};

export const noResults: CSSProperties = {
  textAlign: "center",
  padding: 20,
};

export const debugMenu: CSSProperties = {
  position: "fixed",
  left: -90,
  width: 100,
  top: 0,
  zIndex: 5,
  bottom: 0,
  background: greys.white,
  transition: "left 200ms",

  "&:hover": {
    left: 0,
  },
};

const badgePro: CSSProperties = {
  marginLeft: 10,
};

const underline: CSSProperties = {
  textDecoration: "underline",
  textDecorationStyle: "dashed",
};

export const createTeamBtn: CSSProperties = {
  marginBottom: 14,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: greys.borderGrey,
  borderRadius: 10,
  justifyContent: "flex-start",
  paddingTop: 12,
  paddingBottom: 12,
};

export const createTeamBtnIcon: CSSProperties = {
  width: 36,
  marginRight: 6,
};

export const createTeamBtnText: CSSProperties = {
  paddingTop: 3,
};

export const styles = {
  singleContainer,
  header,
  subHeader,
  body,
  configurationPane,
  pills,
  control,
  controlContent,
  warningIcon,
  warningLabel,
  teamSizeWarning,
  stickyContainer,
  teamSettingsSearchContainer,
  illustration,
  checkList,
  teamSearchTextField,
  noResults,
  debugMenu,
  badgePro,
  underline,
  controlWithWarning,
  createTeamBtn,
  createTeamBtnIcon,
  createTeamBtnText,
};
